module.exports = __webpack_public_path__ + "img/car1_4.c2e3e0b7.png";